import { render } from "./WebinarBoard.vue?vue&type=template&id=15404488"
import script from "./WebinarBoard.vue?vue&type=script&lang=js"
export * from "./WebinarBoard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__